import { GermanFlagIcon, UKFlagIcon, USFlagIcon } from './FlagIcons';
import { BrainIcon } from './BrainIcon';

export { GermanFlagIcon, UKFlagIcon, USFlagIcon, BrainIcon };
